import { type ReactNode } from "react";
import { cn } from "@/lib/utils";

export const MobileContent = ({
  children,
  search = false,
}: {
  children: ReactNode;
  /** The page header also holds a search field, so it is taller. */
  search?: boolean;
}) => (
  <main
    className={cn(
      "max-w-screen-xl mx-auto px-4 pb-20 min-h-screen overflow-y-auto",
      search ? "pt-28" : "pt-18",
    )}
    id="main-content"
  >
    {children}
  </main>
);
